// Copyright (c) 2016 Deere & Company

import Product from '../../shared/state/product';
import actions from '../../../../sharedmodules/actions-list';
import { getDefaultState } from '../state';

const updateProduct = (state, action) => Product.update(state, {
    $set: action.data,
});

const resetProductDetails = () => getDefaultState().product;

const actionTypes = {
    [actions.UPDATE_NEW_TRANSFER_PRODUCT_SUCCESS]: updateProduct,
    [actions.RESET_PRODUCT_CUSTOMER_DETAILS]: resetProductDetails,
};

export default (state = getDefaultState().product, action) => {

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};
